"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarSankrantiItem } from "@/lib/api/calendar";

export interface SankrantiYearData {
  year: number;
  sankrantis: CalendarSankrantiItem[];
}

export default function SankrantiDates({ years }: { years: SankrantiYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, sankrantis }) => ({ year, entries: sankrantis }))}
      tabLabel="Sankranti"
      itemHeader="Sankranti"
      detailHeader="Hindu month"
      emptyMessage="Sankranti dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every solar Sankranti with its lunar month."
      footer="All Sankranti dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — the Sun's exact solar ingress into each rashi, not a fixed calendar."
    />
  );
}
